import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentSettings } from '../models/environment-settings';
import { User, UserOwner } from '../models/user';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class GeneralStoreService {
  private token: BehaviorSubject<string>;
  private user: BehaviorSubject<User>;
  private menu: BehaviorSubject<any>;
  private selectedOwner: BehaviorSubject<UserOwner>;
  private owners: BehaviorSubject<UserOwner[]>;
  private environmentSettings: BehaviorSubject<EnvironmentSettings>;

  // initialize environmentSettings with defaults
  defaultSettings: EnvironmentSettings = {
    splashImageUrl: './assets/images/warehouse5.jpg',
    portalLogoUrl: 'assets/images/optsol.png',
    poweredByUrl: 'assets/images/logo.png',
    faviconUrl: './assets/images/purple-logo.png',
    environmentCode: 'UNKNOWN',
    environmentName: environment.production ? 'Production' : 'Quality Assurance',
    showEnvironmentName: !environment.production,
    portalName: 'Customer Portal'
  };
  constructor(
    private titleService: Title
  ) {
    this.token = new BehaviorSubject<string>(localStorage.getItem('token'));
    this.user = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
    this.menu = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('menu') === 'undefined' ? '[]' : localStorage.getItem('menu')));
    this.selectedOwner = new BehaviorSubject<UserOwner>(JSON.parse(localStorage.getItem('owner')));
    this.owners = new BehaviorSubject<UserOwner[]>(JSON.parse(localStorage.getItem('owners')) || []);


    let settingsToUse: EnvironmentSettings = null;
    if (localStorage.getItem('environmentSettings') !== null && localStorage.getItem('environmentSettings') !== undefined && localStorage.getItem('environmentSettings') !== 'undefined') {
      const foundSettings: EnvironmentSettings = JSON.parse(localStorage.getItem('environmentSettings'));
      this.titleService.setTitle(foundSettings.portalName);
      settingsToUse = foundSettings;
    } else {
      settingsToUse = this.defaultSettings;
    }

    this.environmentSettings = new BehaviorSubject<EnvironmentSettings>(settingsToUse);

  }

  public getToken(): Observable<string> {
    return this.token.asObservable();
  }

  public getTokenValue(): string {
    return this.token.value;
  }

  public getUser(): Observable<User> {
    return this.user.asObservable();
  }

  public getUserValue(): User {
    return this.user.value;
  }

  public getEnvironmentSettings(): Observable<EnvironmentSettings> {
    return this.environmentSettings.asObservable();
  }

  public getMenu(): Observable<any> {
    return this.menu.asObservable();
  }

  public getMenuValue(): any {
    return this.menu.value;
  }

  public getOwners(): Observable<UserOwner[]> {
    return this.owners.asObservable();
  }

  public getOwnersValue(): UserOwner[] {
    return this.owners.value;
  }

  public setToken(token: string): void {
    localStorage.setItem('token', token);
    return this.token.next(token);
  }

  public setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
    return this.user.next(user);
  }

  public setMenu(menu: any): void {
    localStorage.setItem('menu', JSON.stringify(menu));
    return this.menu.next(menu);
  }

  public getSelectedOwner(): Observable<UserOwner> {
    return this.selectedOwner.asObservable();
  }

  public getSelectedOwnerValue(): UserOwner {
    return this.selectedOwner.value;
  }

  public setSelectedOwner(userOwner: UserOwner): void {
    localStorage.setItem('owner', JSON.stringify(userOwner));
    return this.selectedOwner.next(userOwner);
  }

  public setOwners(owners: UserOwner[]): void {
    localStorage.setItem('owners', JSON.stringify(owners));
    return this.owners.next(owners);
  }

  public setEnvironmentSettings(settings: EnvironmentSettings): void {
    settings.splashImageUrl = settings.splashImageUrl ?? this.defaultSettings.splashImageUrl;
    settings.portalLogoUrl = settings.portalLogoUrl ?? this.defaultSettings.portalLogoUrl;
    settings.poweredByUrl = settings.poweredByUrl ?? this.defaultSettings.poweredByUrl;
    settings.faviconUrl = settings.faviconUrl ?? this.defaultSettings.faviconUrl;
    settings.environmentCode = settings.environmentCode ?? this.defaultSettings.environmentCode;
    settings.environmentName = settings.environmentName ?? this.defaultSettings.environmentName;
    settings.showEnvironmentName = settings.showEnvironmentName ?? this.defaultSettings.showEnvironmentName;
    settings.portalName = settings.portalName ?? this.defaultSettings.portalName;

    localStorage.setItem('environmentSettings', JSON.stringify(settings));

    if (settings.portalName) {
      this.titleService.setTitle(settings.portalName);
    }

    if (settings.faviconUrl) {
      const favIcon: HTMLLinkElement = document.querySelector('#appIcon');
      favIcon.href = settings.faviconUrl;
    }

    return this.environmentSettings.next(settings);
  }

  public logout(): void {
    this.setToken('');
    this.setUser(null);
    this.setMenu(null);
    this.setMenu(null);
    this.setOwners([]);
    // this.setEnvironmentSettings(null);
    localStorage.clear();
  }
}
